<template>
    <div class="aboutUP">
        <div class="aboutUP-top">
            <i v-if="showType">
                <router-link to="/mine">
                    <img src="../../../static/images/shootShop/back.png" />
                </router-link>
            </i>
            <i v-else></i>
            <h3>关于租铺宝</h3>
        </div>
        <!-- 优铺介绍 -->
        <div class="aboutUP-wrap">
            <div class="up-introduce">
                <dl>
                    <dt>
                        <img src="../../../static/images/aboutUP/newlogo.png" class="upLogo" />
                        <div class="up-titel">
                            <h2>租铺宝介绍</h2>
                            <i></i>
                            <p>Company Profile</p>
                        </div>
                    </dt>
                </dl>
                <div class="introduce-info">
                    <p
                        class="paragraph"
                    >优铺深耕于商业地产垂直细分市场，着力打造商业地产全产业链互联网生态圈。公司于2016年6月成立，总部设立北京。2018年5月取得8项软件著作权，2018年6月“优铺”商标通过国家商标总局审批，2019年7月17日，获得北京市高新技术企业认证。</p>
                    <p
                        class="paragraph"
                    >租铺宝为优铺旗下大数据驱动的全价值链商铺交易平台，于2018年4月正式上线运营，目前已经北京、上海、广州、深圳、成都、重庆、天津、济南、沈阳等15座城市布局成功服务近万名客户，收录真实商铺近40万套，平台累计用户突破50万。</p>
                    <p
                        class="paragraph"
                    >租铺宝自运营以来，通过大数据、云计算、AI等前沿技术与商铺租赁交易更好的融合，依托真实海量的品牌、商户、店主、房东资源，公开透明的交易原则，专业精准的匹配服务，重构商铺租赁体验，提高商铺租赁效率。</p>
                    <img src="../../../static/images/aboutUP/sm.png" alt class="introduce-img" />
                    <div class="paragraph-title">租铺宝发展历程</div>
                    <img src="../../../static/images/aboutUP/times.png" alt class="times" />
                    
                </div>
            </div>

            <!-- 创始人 -->
            <div class="founder">
                <div class="up-titel">
                    <h2>创始人</h2>
                    <i></i>
                    <p>Founder</p>
                </div>
                <dl>
                    <dt>
                        <img src="../../../static/images/aboutUP/boss.png" />
                        <p>陈云峰</p>
                    </dt>
                    <dd>
                        <h2 class="boss-job">（ 现任优铺网 创始人、董事长、中经联盟 创始人、秘书长 ）</h2>
                    </dd>
                </dl>
                <div class="boss-introduce">
                    <div class="title">职业经历</div>
                    <p
                        class="paragraph"
                    >曾经是国美电器的核心人物，30岁就担任国美电器北京总部第一任全国营销总监和管理中心总经理；历任天津国美电器第一任总经理、上海国美电器总经理，香港国美电器开业副总指挥，为国美的发展立下汗马功劳，在零售服务业积累了丰富的经验。</p>
                    <p
                        class="paragraph"
                    >2005年转战房地产行业，亲历中国房地产飞速发展的18年。曾任鹏润地产（明天房地产）营销总监、总经理集团副总裁, 家乐园集团总裁，上市公司华业地产副总裁，负责北京、深圳、长春、大连、武汉、三亚营销与开发工作，是名副其实的地产专家级操盘手，深谙商业地产开发之道。</p>
                    <p
                        class="paragraph"
                    >2008年，牵头创立中国房地产业行业最具影响力的主流社群——中经联盟，业内称为中国房地产经理人联盟，担任秘书长，成为近万名房地产开发商高管的精神家园</p>
                    <p class="paragraph">2016年，创立优铺网，担任董事长。</p>
                    <p class="paragraph">2018年，成立优铺商学院，担任董事长。</p>
                </div>
                <div class="boss-introduce">
                    <div class="title">社会职务</div>
                    <p class="paragraph">中经联盟（中国房地产经理人联盟）秘书长</p>
                    <p class="paragraph">北京促进雄安产业发展促进会副会长</p>
                    <p class="paragraph">上海长宁区13届政协委员</p>
                    <p class="paragraph">中房经联商业地产专委会主席</p>
                    <p class="paragraph">天津工商联房地产商会商业地产专委会执行主任</p>
                    <p class="paragraph">河北省住宅与房地产协会商业地产专业委员会主任</p>
                    <p class="paragraph">北京理工大学客座教授</p>
                    <p class="paragraph">CCTV、BTV、中央人民广播电台经济之声房地产特邀评论员</p>
                    <br/>
                    <div class="up-titel">
                    <h2>联系优铺</h2>
                    <i></i>
                    <p>Contact</p>
                    </div>
                    <p class="paragraph">联系电话：010-85951005</p>
                    <p class="paragraph">电子邮箱：youpuchina@126.com</p>
                    <p class="paragraph">公司地址：北京市东城区崇文门哈德门大厦东塔801室</p>
                    <p class="paragraph">交通方式：地铁5号线崇文门站 G口</p>
                    <!-- <span style="color:white">2022-09-17</span> -->
                    <!-- <span style="color:white">2022-10-22</span> -->
                    <!-- <span style="color:#F5F5F5">2023-05-29</span> -->
                    <!-- <span style="color:#F5F5F5">2023-12-21</span> -->
                    <!-- <span style="color:#F5F5F5">2024-05-08</span> -->
                    <span style="color:#F5F5F5">2025-06-17</span>
                </div>
            </div>
            
            <div class="tel-phone">
                <img src="../../../static/images/aboutUP/tel010859.png" alt @click="telPhoneFun" />
            </div>

        </div>
    </div>
</template>

<script>
export default {
  name: "aboutUP",
  data() {
    return {
      showType: true,
      move: "",
    };
  },
  computed: {},
  mounted() {
    //截取Url里面的参数
    function GetRequest() {
      var urlInfo = location.search; //获取url中"?"符后的字串
      // alert(window.location.host)
      // alert(urlInfo);
      var theRequest = new Object();
      if (urlInfo.indexOf("?") != -1) {
        var str = urlInfo.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    }
    //通过url取数
    var request = new Object();
    request = GetRequest();
    var move = request["move"];
    var showType1 = request["type"];

    this.move = move;

    if (move == "android") {
      $(".aboutUP-top").hide();
      $(".up-introduce dl").css({ "padding-top": ".5rem" });
    }
    if (showType1 == "app") {
      this.showType = false;
    }
  },
  methods: {
    // 拨打咨询电话
    telPhoneFun() {
      if (this.move == "android") {
        return AndroidDial.showToast("01085951005");
      } else {
        window.location.href = "tel:01085951005";
      }
    }
  },
  created() {}
};
</script>

<style scoped lang="scss">
.payment {
  width: 7.5rem;
  background: #f7f8fa;
}
.aboutUP-top {
  width: 7.5rem;
  height: 1rem;
  text-align: center;
  background: #fff;
  border-bottom: 0.02rem solid #eee;
  position: fixed;
  top: 0;
  z-index: 1000000;
  h3 {
    width: 75%;
    line-height: 1rem;
    font-size: 0.36rem;
    color: #333;
    float: left;
    text-align: center;
  }
  i {
    display: inline-block;
    width: 13%;
    height: 1rem;
    line-height: 1rem;
    float: left;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    img {
      width: 0.22rem;
      height: 0.37rem;
    }
  }
}

.aboutUP-wrap {
  width: 7.5rem;
  background: #fff;
}
/*UP简介*/
.up-introduce {
  width: 100%;
  padding: 0 0.3rem;
  background: #fff;
  box-sizing: border-box;
  dl {
    padding-top: 1rem;
    dt {
      text-align: center;
      .upLogo {
        display: inline-block;
        width: 4.62rem;
        height: 0.8rem;
        margin: 0.83rem auto 0.77rem;
      }
    }
  }
  .introduce-info {
    margin-top: 0.2rem;
    .paragraph {
      font-size: 0.26rem;
      color: #0f1923;
      font-family: PingFang SC;
      line-height: 0.5rem;
      font-weight: 400;
      margin-bottom: 0.1rem;
    }
    .introduce-img {
      width: 5.8rem;
      height: 5.7rem;
      margin-top: 0.45rem;
    }
    .paragraph-title {
      font-size: 0.28rem;
      color: #0f1923;
      font-family: PingFang SC;
      font-weight: 600;
      margin: 0.6rem 0;
    }
    .times {
      width: 4.91rem;
      height: 12.11rem;
      margin-bottom: 0.6rem;
    }
  }
}

/* 创始人 */
.founder {
  width: 100%;
  background: #f6f6f8;
  padding: 0.48rem 0.3rem;
  box-sizing: border-box;
  dt {
    text-align: center;
    margin-top: 0.5rem;
    img {
      width: 3.5rem;
      height: 3.5rem;
    }
    p {
      color: #1f2d6f;
      font-size: 0.3rem;
      margin-top: 0.2rem;
    }
  }
  dd {
    margin-top: 0.1rem;
    h2 {
      margin-bottom: 0.1rem;
      font-size: 0.22rem;
      color: #333333;
      text-align: center;
    }
    h3 {
      font-size: 0.3rem;
      color: #333;
    }
  }
  .boss-introduce {
    margin-bottom: 0.3rem;
    .title {
      color: #585f6b;
      font-size: 0.26rem;
      font-family: PingFang SC;
      margin-bottom: 0.2rem;
    }
    .paragraph {
      color: #0f1923;
      font-size: 0.24rem;
      line-height: 0.38rem;
      margin-bottom: 0.1rem;
      font-family: PingFang SC;
    }
  }
}

/*咨询电话*/
.tel-phone {
  background: #fff;
  height: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  img {
    width: 7.05rem;
    height: 1.13rem;
  }
}

/*标题封装*/
.up-titel {
  width: 7.1rem;
  height: 1.2rem;
  text-align: center;
  h2 {
    font-size: 0.36rem;
    font-weight: 600;
    color: #111;
    margin-bottom: 0.1rem;
  }
  i {
    width: 2.67rem;
    height: 0.02rem;
    background: #ccc;
    display: inline-block;
    position: relative;
    top: -0.32rem;
    margin-top: 0.2rem;
  }
  p {
    position: relative;
    top: -0.4rem;
    color: #585f6b;
    font-size: 0.2rem;
  }
  .pmgressbar {
    width: 1.2rem;
    height: 0.08rem;
    line-height: 0.6rem;
    margin-top: 0.01rem;
  }
}
</style>
















// WEBPACK FOOTER //
// src/components/mine/aboutUP.vue